import { useArchiveFriendAction } from "@/entities/friend/lib/use-archive-friend-action"
import * as m from "@/paraglide/messages"
import ArrowUndoIcon from "@/shared/assets/coolicons/Arrow/Arrow_Undo_Up_Left.svg?react"
import ArchiveIcon from "@/shared/assets/coolicons/File/Archive.svg?react"
import type { Friend } from "../model/types"

interface ArchiveFriendButtonProps {
	friend: Friend
}

/** Строка «Отправить в архив» / «Вернуть на главную» в профиле контакта. */
export function ArchiveFriendButton({ friend }: ArchiveFriendButtonProps) {
	const { archive, unarchive, isPending } = useArchiveFriendAction()
	const isArchived = friend.is_archived

	const handleClick = () => {
		if (isArchived) {
			void unarchive(friend)
		} else {
			void archive(friend)
		}
	}

	const Icon = isArchived ? ArrowUndoIcon : ArchiveIcon

	return (
		<button
			type="button"
			onClick={handleClick}
			disabled={isPending}
			className="isolate flex h-11.75 w-full flex-col items-start justify-center gap-1.75 rounded-t-lg bg-white px-3 py-0 disabled:opacity-50"
		>
			<div className="flex w-full flex-row items-center justify-start gap-2.5">
				<Icon className="size-6 shrink-0 text-[#282a33]" />
				<span className="text-center text-base leading-5 font-medium text-[#282a33]">
					{isArchived ? m.unarchiveBtn() : m.archiveMenuSendBtn()}
				</span>
			</div>
		</button>
	)
}
